export default __webpack_public_path__ + "b1d37b7a76c5a3d7dc03b16fdc291812.jpg";